module.exports = __webpack_public_path__ + "img/DSC_7057.08ddc8f0.jpg";